import { Button, Card, Form, FormProps, Row, Space } from 'antd';
import { ButtonProps } from 'antd/lib';

interface FilterFormProps {
  searchFormProps: FormProps;
  children: React.ReactNode;
  okButtonProps?: ButtonProps;
  // Por padrão "Limpar filtro" faz resetFields(), que devolve o formulário aos
  // initialValues. Telas que abrem com um filtro pré-aplicado e querem que o
  // botão liste tudo passam o seu próprio onClear.
  onClear?: () => void;
}

const FilterForm = ({
  searchFormProps,
  children,
  okButtonProps,
  onClear
}: FilterFormProps) => {
  const handleClear = () => {
    if (onClear) {
      onClear();
      return;
    }

    searchFormProps.form?.resetFields();
    searchFormProps.form?.submit();
  };

  return (
    <Card className="filter-form-card p-2 mb-3" size="small">
      <Form {...searchFormProps} layout="horizontal">
        <Row
          align="middle"
          justify="start"
          className="gap-4 [&>.ant-form-item]:mb-0"
        >
          {children}
          <Space className="ml-auto">
            <Button type="default" onClick={handleClear}>
              Limpar filtro
            </Button>
            <Button type="primary" htmlType="submit" ghost {...okButtonProps}>
              Filtrar
            </Button>
          </Space>
        </Row>
      </Form>
    </Card>
  );
};

export default FilterForm;
